// =============================================================================================================================================
// 15-04-2026

// ── Announcement bar rotator (both desktop + mobile tracks) ──
function initAnnRotator(trackId){
  const track = document.getElementById(trackId);
  if(!track) return;
  const total = track.children.length - 1;
  let current = 0;
  function next(){
    current++;
    track.style.transition = 'transform .6s cubic-bezier(.4,0,.2,1)';
    track.style.transform = 'translateY(-' + (current * 36) + 'px)';
    if(current >= total){
      setTimeout(()=>{
        track.style.transition = 'none';
        track.style.transform = 'translateY(0)';
        current = 0;
      }, 650);
    }
  }
  setInterval(next, 3000);
}
initAnnRotator('annTrackDesktop');
initAnnRotator('annTrackMobile');

// ── Footer accordion (mobile) ──
function toggleFooterAcc(header){
  const body = header.nextElementSibling;
  const plus = header.querySelector('.footer-acc-plus');
  const isOpen = body.classList.contains('open');
  document.querySelectorAll('.footer-acc-body').forEach(b=>b.classList.remove('open'));
  document.querySelectorAll('.footer-acc-plus').forEach(p=>p.textContent='+');
  if(!isOpen){body.classList.add('open');plus.textContent='\u2212';}
}

// faq open 
document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".faq-item");

  function slideUp(element, duration = 300) {
    element.style.height = element.offsetHeight + "px";
    element.offsetHeight; // force repaint

    element.style.transition = "height " + duration + "ms ease";
    element.style.height = 0;

    setTimeout(() => {
      element.style.display = "none";
      element.style.removeProperty("height");
      element.style.removeProperty("transition");
    }, duration);
  }

  function slideDown(element, duration = 300) {
    element.style.display = "block";
    let height = element.scrollHeight;

    element.style.height = 0;
    element.offsetHeight;

    element.style.transition = "height " + duration + "ms ease";
    element.style.height = height + "px";

    setTimeout(() => {
      element.style.removeProperty("height");
      element.style.removeProperty("transition");
    }, duration);
  }

  items.forEach((item) => {
    item.addEventListener("click", () => {

      items.forEach((el) => {
        if (el !== item) {
          el.classList.remove("active");
          const ans = el.querySelector(".faq-answer");
          if (ans && ans.style.display === "block") {
            slideUp(ans);
          }
        }
      });

      const answer = item.querySelector(".faq-answer");

      if (!answer) return;

      if (item.classList.contains("active")) {
        item.classList.remove("active");
        slideUp(answer);
      } else {
        item.classList.add("active");
        slideDown(answer);
      }
    });
  });
});

document.querySelectorAll('.video-wrapper').forEach(wrapper => {
  const video = wrapper.querySelector('video');

  // Ensure muted for autoplay
  video.muted = true;
  video.playsInline = true;

  // 🔥 Autoplay on load
  video.play().then(() => {
    wrapper.classList.add('playing');
  }).catch(err => {
    console.log('Autoplay blocked:', err);
  });

  // Click to toggle play/pause + unmute
  wrapper.addEventListener('click', () => {
    if (video.paused) {
      video.muted = false; // unmute on interaction
      video.play();
      wrapper.classList.add('playing');
    } else {
      video.pause();
      wrapper.classList.remove('playing');
    }
  });
});
// collection Quick add
$('.quick-trigger').click(function(){
   $('.quick-overlay').removeClass('active');
   $(this).parents('.bs-img').find('.quick-overlay').addClass('active')
})
$('.qo-size-btn').click(function(){
   $('.qo-size-btn').removeClass('active');
   $(this).addClass('active')
    var value = $(this).attr('data-id');
    $('.quick-overlay .bs-quick-add.multiple').attr('data-id',value)
})
$(document).on('click', '.quick-add, .bs-quick-add, .quick-add-collection', function (e) {
  e.preventDefault();

  let $btn = $(this).closest('.bs-quick-add');

  let variantId = $btn.attr('data-id'); // 🔥 use attr not data()
 if (!variantId) {
    let selectedVariant = $btn.closest('.quick-overlay').find('.qo-size-btn.active');

    if (selectedVariant.length) {
      variantId = selectedVariant.attr('data-id');
      $btn.attr('data-id', variantId); 
    } else {
      alert('Please select a size');
      return;
    }
  }
  console.log('variantId  ',variantId);

  if (!variantId) {
    console.log('Variant ID missing');
    return;
  }

  if ($btn.hasClass('loading')) return;

  $btn.addClass('loading').prop('disabled', true).addClass('disabled');

  // 🟢 ADD TO CART
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      id: variantId,
      quantity: 1
    },
    dataType: 'json',

    success: function () {

      // 🟢 GET UPDATED SECTIONS
      $.ajax({
        type: 'GET',
        url: '/?sections=cart-drawer,page-header',
        dataType: 'json',

        success: function (sections) {
          $('.quick-overlay').removeClass('active');

          console.log('Sections:', sections);

          let drawer = document.querySelector('.js-cart-drawer');
          let header = document.querySelector('.page-header');

          // 🟢 UPDATE CART DRAWER
          if (drawer && sections['cart-drawer']) {

            if (typeof drawer.updateFromCartChange === 'function') {
              drawer.updateFromCartChange(sections['cart-drawer']);
            } else {
              drawer.innerHTML = sections['cart-drawer'];
            }
          }

          // 🟢 UPDATE HEADER (CART COUNT ETC)
          if (header && sections['page-header']) {

            if (typeof header.updateFromCartChange === 'function') {
              header.updateFromCartChange(sections['page-header']);
            } else {
              header.innerHTML = sections['page-header'];
            }
          }

          // 🟢 OPEN DRAWER
          if (drawer && typeof drawer.open === 'function') {
            drawer.open($btn[0]);
          }

          // 🟢 REMOVE FOCUS (UX FIX)
          setTimeout(function () {
            if (document.activeElement) {
              document.activeElement.blur();
            }
          }, 300);

          // 🟢 CUSTOM EVENT
          $(document).trigger('custom:cart:added');
        },

        error: function (err) {
          console.log('Section load error:', err);
        }
      });
    },

    error: function (err) {
      console.log('Error adding product:', err);
    },

    complete: function () {
      setTimeout(function () {
        $btn.removeClass('loading')
            .prop('disabled', false)
            .removeClass('disabled');
      }, 800);
    }
  });

});

// ── Material swatch links: force navigation, immune to click-hijacking (24-07-2026) ──
document.addEventListener('click', function(e){
  var link = e.target.closest ? e.target.closest('a.material-item') : null;
  if (link) {
    var href = link.getAttribute('href');
    if (href && href !== '#') {
      e.preventDefault();
      e.stopPropagation();
      window.location.href = href;
    }
  }
}, true);
